import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router";

import { useGetFullInquiry } from "@equidefi/portals/hooks/useInquiries";
import { INQUIRY_TYPE } from "@equidefi/shared";

import { useInvestment } from "@/hooks/useInvestments";

import InquiryKYBDetails from "./InquiryKYBDetails";
import InquiryKYCDetails from "./InquiryKYCDetails";

const InquiryDetailsPage = () => {
  const { id, inquiryId } = useParams<{ id: string; inquiryId: string }>();
  const { data: investment } = useInvestment(id);

  const params =
    id && investment?.vault?.entity_type && investment?.vault?.citizenship
      ? {
          investmentId: id,
          entityType: investment.vault.entity_type,
          citizenship: investment.vault.citizenship,
        }
      : undefined;

  const { data: inquiry, isFetched } = useGetFullInquiry(inquiryId, params);

  if (!isFetched || !inquiry) {
    return (
      <Center h="100vh">
        <Spinner />
      </Center>
    );
  }

  return inquiry.type === INQUIRY_TYPE.KYB ? (
    <InquiryKYBDetails inquiry={inquiry} />
  ) : (
    <InquiryKYCDetails inquiry={inquiry} />
  );
};

export default InquiryDetailsPage;
